import { useTranslation } from "react-i18next";
import { Navigation, Clock } from "lucide-react";
import { Button, Card, CardContent } from "@tabipla/ui";
import type { SpotResponseDto } from "@tabipla/shared";
import { getGoogleMapsUrl } from "@/utils/google-maps";

interface NextSpotCardProps {
  nextSpot: SpotResponseDto | null;
}

export function NextSpotCard({ nextSpot }: NextSpotCardProps) {
  const { t } = useTranslation();

  return (
    <Card className="border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-950">
      <CardContent className="p-4">
        {nextSpot ? (
          <div className="flex items-center gap-4">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-green-500 text-white">
              <Navigation className="h-6 w-6" />
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-medium text-green-700 dark:text-green-300">
                {t("trips.nextSpot.title")}
              </p>
              <h3 className="truncate text-lg font-bold text-green-900 dark:text-green-100">
                {nextSpot.name}
              </h3>
              <p className="text-sm text-green-600 dark:text-green-400">
                {nextSpot.startTime} - {nextSpot.endTime}
                {nextSpot.location && ` • ${nextSpot.location}`}
              </p>
            </div>
            {nextSpot.location && (
              <Button
                size="sm"
                className="shrink-0 bg-green-600 hover:bg-green-700"
                onClick={() => {
                  const url = getGoogleMapsUrl(nextSpot);
                  if (url) window.open(url, "_blank");
                }}
              >
                <Navigation className="mr-1 h-4 w-4" />
                {t("trips.nextSpot.navigate")}
              </Button>
            )}
          </div>
        ) : (
          <div className="flex items-center gap-3 text-green-700 dark:text-green-300">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-green-200 dark:bg-green-800">
              <Clock className="h-5 w-5" />
            </div>
            <p className="font-medium">{t("trips.nextSpot.noMore")}</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
